import gql from 'graphql-tag'

/**
 * Query
 */
const GET_ALL = gql`
  query discountTypes {
    discountTypes {
      id
      name
      is_law
      is_active
      status_text
    }
  }
`

const ALL_ACTIVE = gql`
  query discountTypesActive {
    discountTypesActive {
      id
      name
      is_law
      is_active
      status_text
    }
  }
`
const GET_WITH_PAGINATION = gql`
  query discountTypesWithPagination ($page: Int, $perPage: Int) {
    discountTypesWithPagination (page: $page, first: $perPage) {
      paginatorInfo {
        currentPage
        count
        hasMorePages
        perPage
        total
      }
      data {
        id
        name
        is_law
        is_active
        status_text
      }
    }
  }
`
/**
 * Mutations
 */
 const CREATE = gql`
  mutation createDiscountType ($input: DiscountTypeInput!) {
    createDiscountType (input: $input) {
      id
      name
      is_law
      is_active
      status_text
    }
  }
`

const UPDATE = gql`
  mutation updateDiscountType ($id: ID!, $input: DiscountTypeInput!) {
    updateDiscountType (id: $id, input: $input) {
      id
      name
      is_law
      is_active
      status_text
    }
  }
`

const DELETE = gql`
  mutation deleteDiscountType ($id: ID!) {
    deleteDiscountType (id: $id) {
      id
    }
  }
`
export {
  ALL_ACTIVE,
  GET_WITH_PAGINATION,
  CREATE,
  UPDATE,
  DELETE,
  GET_ALL
}
